// The words a panel row in the Coordinator Workbench is drawn with (lane B6 S10, CR-086 "acknowledgments appear in
// Coordinator Workbench", CR-074 "Decline and nonresponse status visible to Coordinator."). The server counts both
// sources into Awaiting Interviewer Availability and carries the record's own status in the row key
// (`<source>:<id>:<status>`); the screen draws that status with its own machine's word.

import { ACKNOWLEDGMENT_STATUS, PANEL_CHANGE_STATUS, RESPONSE_STATUS } from "@/mc";

const ACK_WORD: Readonly<Record<string, string>> = {
  pending: ACKNOWLEDGMENT_STATUS.acknowledgmentPending,
  declined: ACKNOWLEDGMENT_STATUS.declined,
  nonresponse: RESPONSE_STATUS.nonresponse,
};

/** The open change statuses the Workbench lists (`workbench_rows.CHANGE_OPEN`). */
const CHANGE_WORD: Readonly<Record<string, string>> = {
  submitted: PANEL_CHANGE_STATUS.submitted,
  pending_recruiter_review: PANEL_CHANGE_STATUS.pendingRecruiterReview,
  pending_hm_review: PANEL_CHANGE_STATUS.pendingHmReview,
  blocked: PANEL_CHANGE_STATUS.blocked,
  approved: PANEL_CHANGE_STATUS.approved,
  communicated: PANEL_CHANGE_STATUS.communicated,
};

/** The record's own status word for a panel row, or null for any other row (the scheduling status word stands). */
export function panelRowWord(row: { source: string; key: string }): string | null {
  const status = row.key.slice(row.key.lastIndexOf(":") + 1);
  if (row.source === "panel_acknowledgment") return ACK_WORD[status] ?? null;
  if (row.source === "panel_change") return CHANGE_WORD[status] ?? null;
  return null;
}
